import React from 'react'
import {Button} from './core/button.js'

export default class ManualScreen extends React.Component{

	render(){
		const {
			data,
			lang,
			handler
		} = this.props
		const manualscreenData = data.screen_2
		const instruction = manualscreenData.text
		const icons = manualscreenData.icons
		const assetpath = lang.concat('/screen_2/')

		return(
			<div className='manualContainer'>
				<div className='intro'>{instruction}</div>
				<Button
					className={'bottomButton button'}
					name={'Dreh am Glücksrad'}
					handler={handler}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/manualScreen.js